import { MOBILE_BREAKPOINT } from '../constants'

export const isMobileWidth = () => window.innerWidth < MOBILE_BREAKPOINT
